import { useMemo } from 'react'
import { getSubdomain, parse } from 'tldts'
import URL from 'url-parse'
import getEnv from 'utilities/getEnv'
export interface IUrlProperties {
    hostname: string | null
    isIp: boolean | null
    subdomain: string | null
    domain: string | null
    publicSuffix: string | null
    domainWithoutSuffix: string | null
    isIcann: boolean | null
    isPrivate: boolean | null
}

export const parseSubdomainWithUrl = (url: string) => {
    let subdomain = getSubdomain(url)

    if (subdomain === 'www') {
        subdomain = ''
    } else if (subdomain?.startsWith('www.')) {
        subdomain = subdomain.replace('www.', '')
    }
    return subdomain ?? ''
}

function useSubdomain() {
    const subdomain = parseSubdomainWithUrl(window.location.href)
    const hasSubDomain = useMemo(() => {
        const isIp = parse(window.location.href).isIp
        return Boolean(getEnv('LOCAL_WITHOUT_PWA')) || isIp || !!subdomain
    }, [subdomain])

    const fullUrl = useMemo(() => {
        const properties = new URL(window.location.href)
        return `${properties.origin}`
    }, [])

    const isLocalhost = fullUrl.includes('localhost')
    return {
        hasSubDomain: hasSubDomain || isLocalhost,
        fullUrl,
        subdomain,
    }
}

export default useSubdomain
